<i18n>
{
  "cl":{
    "error-getBrokersList": "Ocurrió un error al tratar de obtener los brokers.",
    "list-title": "Brokers disponibles"
  },
  "pe":{
    "error-getBrokersList": "Ocurrió un error al tratar de obtener los brokers.",
    "list-title": "Brokers disponibles"
  },
  "br":{
    "error-getBrokersList": "Ocorreu um erro ao tentar obter os brokers.",
    "list-title": "Brokers disponíveis"
  }
}
</i18n>
<template>
  <div>
    <div class="card-item">
      <div class="columns mx-auto is-multiline header-btn">
        <div class="column is-10-until-widescreen">
          <div class="columns is-multiline header-btn">
            <div class="column is-10-until-widescreen">
              <Spinner v-if="isLoading " />
              <div v-if="!isLoading " class="placeholder-input-container">
                <CreateBrokerButton v-if="!userIsBroker && showCreateBrokerButton" />
                <FindBrokersInput
                  placeholder="Buscar broker"
                  :expanded="true"
                  class="search-broker"
                  @select="goToSingleBrokerView($event._id)" />
              </div>
              <Message v-if="brokers.length === 0 && !isLoading" :message="mainMessage.message" :icon="mainMessage.icon" :as-card="false" />
              <template v-if="!isLoading && brokers.length > 0">
                <h4 v-if="pagination.numberOfDocuments" class="has-text-centered list-title">
                  {{ `${pagination.numberOfDocuments} ${$t("list-title")}` }}
                </h4>
                <BrokersList :brokers-list="brokers" :user-is-broker="userIsBroker" />
                <CredituPagination
                  v-if="!isLoading && brokers.length && !userIsBroker> 0"
                  :documents-per-page.sync="pagination.documentsPerPage"
                  :total="pagination.numberOfDocuments"
                  :page-number.sync="pagination.pageNumber"
                  size="is-small"
                  items-name="Brokers"
                  :range-before="1"
                  :range-after="1"
                  :documents-per-page-options="[5, 10, 20, 50]"
                  @update:documentsPerPage="
                    catchUpdatePagination('setPaginationDocumentsPerPageBroker', $event)
                  "
                  @update:pageNumber="
                    catchUpdatePagination('setPaginationPageNumberBroker', $event)
                  " />
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { dateToFormatedString } from '@/infrastructure/date';
import CredituPagination from '@/ui/components/CredituPagination.vue';
import BrokersList from '@/ui/components/internal/brokers/BrokersList.vue';
import { getBrokerByEmail, getBrokersList } from '@/application/services/api-clients/brokers';
import { getFeatureToggleByName } from '@/application/services/api-clients/features-toggles';
import FindBrokersInput from '../../../components/internal/brokers/FindBrokersInput.vue';
import Spinner from '../../../components/Spinner.vue';
import Message from '../../../components/Message.vue';
import CreateBrokerButton from '../../../components/internal/brokers/CreateBrokerButton.vue';

export default {
  name: 'Brokers',
  components: {
    CreateBrokerButton,
    FindBrokersInput,
    CredituPagination,
    BrokersList,
    Spinner,
    Message
  },
  props: {
    userIsBroker: { type: Boolean, optional: false }
  },
  data() {
    return {
      showCreateBrokerButton: null,
      brokers: [],
      isLoading: false,
      mainMessage: {
        message: '',
        icon: ''
      }
    };
  },
  computed: {
    pagination() {
      return this.$store.state.brokersModule.pagination;
    }
  },
  async mounted() {
    await this.loadBrokers();
    this.showCreateBrokerButton = (await getFeatureToggleByName('internal-frontend-comercial-manager-show-create-broker-button')).isActive;
  },
  methods: {
    async getBrokerByEmail() {
      const { email } = this.$store.state.currentUser.user;

      let response = null;
      try {
        response = await getBrokerByEmail(email);
      } catch (_error) {
        this.mainMessage = {
          message: this.$t('error-getBrokerByEmail'),
          icon: 'data_maintenance.svg'
        };
        this.isLoading = false;
      }
      return response;
    },
    async getBrokersList(getBrokersListInput) {
      let response = null;
      try {
        response = await getBrokersList(getBrokersListInput);
      } catch (_error) {
        this.mainMessage = {
          message: this.$t('error-getBrokersList'),
          icon: 'data_maintenance.svg'
        };
        this.isLoading = false;
      }
      return response;
    },
    goToSingleBrokerView(brokerId) {
      this.$store.state.brokersModule.userIsBroker = this.userIsBroker;
      // Es true porque para llegar a esta componente debe ser broker multiple
      this.$store.state.brokersModule.brokerIsMultiple = true;
      this.$router.push(`broker/${brokerId}`);
    },
    async loadBrokers() {
      this.isLoading = true;

      if (this.userIsBroker) {
        const { brokerList } = await this.getBrokerByEmail();
        if (brokerList) {
          this.brokers = brokerList;
        } else {
          this.brokers = [];
        }
      } else {
        const paramsGetBrokersList = {
          ...this.pagination
        };
        const result = await this.getBrokersList(paramsGetBrokersList);
        if (result !== null && result.getBrokersList) {
          const response = result.getBrokersList[0];
          this.brokers = response.brokers;
          this.$store.dispatch('setCurrentPaginationBroker', response.pagination || {});
        } else {
          this.brokers = [];
          this.$store.dispatch('setCurrentPaginationBroker', {
            documentsPerPage: paramsGetBrokersList.documentsPerPage || 10,
            pageNumber: 1
          });
        }
      }
      this.isLoading = false;
    },
    catchUpdatePagination(prop, value) {
      if (prop === 'setPaginationDocumentsPerPageBroker') {
        this.$store.dispatch('setPaginationPageNumberBroker', 1);
      }
      this.$store.dispatch(prop, value);
      this.loadBrokers();
    },
    formatDate: (date, format = 'DD/MM/YYYY') => dateToFormatedString(date, format)
  }
};
</script>

<style scoped>

.placeholder-input-container{
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1.5rem;
}
.filters-container {
  display:none;
}
.list-title{
  color: var(--nickel)
}
.default-item-date,.default-item-idnumber{
display: flex;
align-items:center;
justify-content: center;
gap:5px;
}
.custom-icon-color{
  color:var(--primary);
}
  h2.brokers{
    margin:20px;
  }
.default-item .default-item-info {
  width: 100%;
  display: grid;
  grid:
    "name idnumber date stage button" auto
    / 1fr 1fr 1fr 1fr 1.5fr ;
  gap: 0rem 1rem;
  place-items: center;
  place-content: center stretch;
}
.header-btn {
  max-width: 1344px;
}
.search-broker {
  margin: auto;
  width: 100%;
}
.content-title {
  color: var(--primary);
  font-weight: 600;
}
.med-size-text {font-size: 0.9rem;}

@media (max-width: 800px) {
  .med-size-text {font-size: 0.75rem;}
}
@media (max-width: 570px) {
.placeholder-input-container{
  justify-content: center;
  flex-wrap: wrap;
}
  .med-size-text {font-size: 0.9rem;}
  .default-item .default-item-info {
    grid:
      "name" auto
      "date" auto
      "stage" auto
      "button" auto
      / auto;
    place-content: center stretch;
  }
.button.is-fullwidth-mobile {
  display: flex;
  width: 100%;
  }
}
@media (max-width: 350px) {
  .med-size-text {font-size: 0.75rem;}
}

</style>
